import { styled } from 'styled-components';
import { getFontSize } from '../../abstracts';
import { Action } from '../Action';
import { Text } from '../Text';
export const Container = styled.div.withConfig({
  componentId: "aui__sc-eyfito-0"
})(["position:fixed;bottom:", ";right:50%;transform:translate(50%);opacity:", ";align-items:center;border-radius:var(--aui-border-radius-100);display:flex;font-size:", ";gap:var(--aui-spacing-100);justify-content:space-between;padding:var(--aui-spacing-050) var(--aui-spacing-100) var(--aui-spacing-050) var(--aui-spacing-200);min-width:max-content;z-index:99999999;pointer-events:", ";background-color:", ";color:", ";transition:bottom 0.3s ease-out,opacity 0.3s linear;[data-aui='icon']{flex-shrink:0;}"], ({
  $isOpen,
  $offset
}) => $isOpen ? `${$offset}rem` : '0', ({
  $isOpen
}) => $isOpen ? '1' : '0', getFontSize(1), ({
  $isOpen
}) => $isOpen ? 'auto' : 'none', ({
  $type
}) => ({
  success: 'var(--aui-status-success)',
  error: 'var(--aui-status-error)',
  default: 'var(--aui-inverse-surface)'
})[$type], ({
  $type
}) => ({
  success: 'var(--aui-status-on-success)',
  error: 'var(--aui-status-on-error)',
  default: 'var(--aui-inverse-on-surface)'
})[$type]);
export const DismissButton = styled(Action).withConfig({
  componentId: "aui__sc-eyfito-1"
})(["color:currentColor;flex-shrink:0;padding:var(--aui-spacing-100);&:hover,&:active{color:currentcolor;box-shadow:none;}"]);
export const Message = styled(Text).attrs({
  size: 1
}).withConfig({
  componentId: "aui__sc-eyfito-2"
})(["margin-right:0.5rem;"]);
export const ActionButton = styled(Action).withConfig({
  componentId: "aui__sc-eyfito-3"
})(["font-size:", ";line-height:1.2;&,&:hover,&:active{color:currentColor;}"], getFontSize(1));